import { render, staticRenderFns } from "./jft.vue?vue&type=template&id=59ace660"
import script from "./jft.vue?vue&type=script&lang=js"
export * from "./jft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports